import React, { useEffect } from 'react';
import RouteChangeTracking from '@Services/RouteChangeTracking';
import Auth from '@Services/Auth';
import { FEATURES } from '@Constants/rx-ui/constants';
import BuildQuery from './BuildQuery';

function BuildQueryContainer(props) {
  useEffect(() => {
    RouteChangeTracking.trackOnRouteChangeSuccess();
  }, []);
  const isAIQuickSearchBannerDisabled = Auth.isFeatureEnabled(FEATURES.disableAIQuickSearchBanner);
  return <BuildQuery {...props} isAIQuickSearchBannerDisabled={isAIQuickSearchBannerDisabled} />;
}

export default BuildQueryContainer;
